module.exports = __webpack_public_path__ + "static/img/A4.2ec18479.jpg";